import { BaseModel } from './basemodel';
import { type ParentOrganization } from './parent-organization';
import { type User } from './user';

export enum OrganizationStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum OrganizationType {
  CUSTOMER = 'CUSTOMER',
  PARTNER = 'PARTNER',
}

export class Organization extends BaseModel {
  name = '';

  address?: string;

  description?: string;

  status?: OrganizationStatus;

  type: OrganizationType = OrganizationType.CUSTOMER;

  parentOrganization?: ParentOrganization;

  parentOrganizationId?: string;

  motherOrganization?: ParentOrganization;

  motherOrganizationId?: string;

  childOrganizations?: ParentOrganization[];

  owner?: User;
}
